import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'
import { useCustomDomain } from '../hooks/useCustomDomain'
import { DEFAULT_OG_IMAGE, SeoValues } from '../helpers/seo'

const SeoHead = ({
  title,
  description,
  robots,
  ogType = 'website',
  ogImage,
  siteName,
}: SeoValues) => {
  const { customDomain } = useCustomDomain()
  const { pathname } = useLocation()
  const resolvedSiteName =
    siteName ||
    (customDomain
      ? customDomain.guild?.name || customDomain.team?.name
      : 'wowaudit')
  const resolvedImage = ogImage || DEFAULT_OG_IMAGE
  const canonical =
    typeof window === 'undefined'
      ? undefined
      : `${window.location.origin}${pathname}`

  return (
    <Helmet>
      {title ? <title>{title}</title> : null}
      {description ? <meta name='description' content={description} /> : null}
      {robots ? <meta name='robots' content={robots} /> : null}
      {canonical ? <link rel='canonical' href={canonical} /> : null}
      {title ? <meta property='og:title' content={title} /> : null}
      {description ? (
        <meta property='og:description' content={description} />
      ) : null}
      <meta property='og:type' content={ogType} />
      {canonical ? <meta property='og:url' content={canonical} /> : null}
      {resolvedImage ? (
        <meta property='og:image' content={resolvedImage} />
      ) : null}
      {resolvedSiteName ? (
        <meta property='og:site_name' content={resolvedSiteName} />
      ) : null}
      <meta
        name='twitter:card'
        content={resolvedImage ? 'summary_large_image' : 'summary'}
      />
      {title ? <meta name='twitter:title' content={title} /> : null}
      {description ? (
        <meta name='twitter:description' content={description} />
      ) : null}
      {resolvedImage ? (
        <meta name='twitter:image' content={resolvedImage} />
      ) : null}
    </Helmet>
  )
}

export default SeoHead
